export enum TipoDocumento {
    INVOICE = "INVOICE",
    TICKET = "TICKET",
    DEBIT_NOTE = "DEBIT_NOTE",
    CREDIT_NOTE = "CREDIT_NOTE",
    PERCEPTION = "PERCEPTION",
    RETENTION = "RETENTION",
    DESPATCH_ADVICE = "DESPATCH_ADVICE",
    DESPATCH_TRANSPORT = "DESPATCH_TRANSPORT",
    SUMMARY_DOCUMENT = 'SUMMARY_DOCUMENT',
    RR_VOIDED_DOCUMENT = 'RR_VOIDED_DOCUMENT',
    RA_VOIDED_DOCUMENT = 'RA_VOIDED_DOCUMENT',
    CORRUPTED_DOCUMENT = 'CORRUPTED_DOCUMENT',
    INVALID_DOCUMENT = 'INVALID_DOCUMENT',
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/tipo-documento.enum.ts